<template>
    <div class="compare-page" id="content">
        
        <div class="grid-wrapper univstudy__app__holder">
            <div class="full-width-grid intro-background margin--l-xl">
                <div class="grid-wrapper">
                    <div v-if="is_compare_programs" class="intro__content">
                        <button 
                            @click.prevent="goBackToPrograms" 
                            @keydown.enter.prevent="goBackToPrograms"
                            
                            class="secondary-button download__button red-color margin--2xs">
                            <span v-html="ico_arrow_left_16"/>
                            {{ printString('back') }}
                        </button>
                        <h1 class="step--7 black-primary">
                            {{ printString('compare_programs') }}
                        </h1>
                    </div>
                    <div v-if="is_compare_schools" class="intro__content">
                        <button 
                            @click="goBackToSchools" 
                            @keydown.enter.prevent="goBackToSchools"
                            
                            class="secondary-button download__button red-color margin--2xs">
                            <span v-html="ico_arrow_left_16"/>
                            {{ printString('back') }}
                        </button>
                        <h1 class="step--7 black-primary">
                            {{ printString('compare_schools') }}
                        </h1>
                    </div>
                </div>      
                <div class="intro-gradient">
                    <div class="intro-gradient__red"></div>
                    <div class="intro-gradient__yellow"></div>
                    <div class="intro-gradient__white"></div>
                    <div class="intro-gradient__white"></div>
                </div>
            </div>

            <ComparePrograms v-if="is_compare_programs"/>
            <CompareSchools v-if="is_compare_schools"/>

        </div>
    </div>
</template>

<script>
import { useRoute, useRouter } from 'vue-router';

import ComparePrograms from './ComparePrograms.vue';
import CompareSchools from './CompareSchools.vue';

export default {
    name: 'Compare',
    components: { ComparePrograms, CompareSchools },
    created() {
        this.route = useRoute();
        this.router = useRouter();
        this.updateCompareType();
    },
    data() {
        return {
            ico_arrow_left_16: window.ico_arrow_left_16,
            is_compare_programs: false,
            is_compare_schools: false,
            site_lang: window.lang,
        }
    },
    mounted() {
        this.updateLanguageSwitcherUrl();
    },
    methods: {
        updateCompareType() {
            const currentPath = this.route.path;
            this.is_compare_programs =  currentPath.endsWith('/compare-programs/') || 
                                        currentPath.endsWith('/compare-programs');
                                        // currentPath.endsWith('/fr/compare-programs/') || 
                                        // currentPath.endsWith('/fr/compare-programs');
            this.is_compare_schools = currentPath.endsWith('/compare-schools/') || 
                                      currentPath.endsWith('/compare-schools');
                                    //   currentPath.endsWith('/fr/compare-schools/') || 
                                    //   currentPath.endsWith('/fr/compare-schools');
        },
        updateLanguageSwitcherUrl() {
            const languageSwitcher = document.querySelector('.languages');
            if (languageSwitcher) {
                const langLink = languageSwitcher.querySelector(`.languages__item:not(.active)`);
                
                if (langLink) {
                    let baseUrl = window.language_switcher_url;
                    let newPath;

                    if (this.site_lang === 'fr') {
                        // We're on French site, building English URL
                        if(this.is_compare_programs){
                            newPath = `/compare-programs/`;
                        } else if(this.is_compare_schools){
                            newPath = `/compare-schools/`;
                        }
                        // Remove '/fr' from the end of baseUrl if it exists
                        baseUrl = baseUrl.replace(/\/fr\//, '');
                    } else {
                        // We're on English site, building French URL
                        if(this.is_compare_programs){
                            newPath = `/compare-programs/`;
                        } else if(this.is_compare_schools){
                            newPath = `/compare-schools/`;
                        }
                    }
                    
                    const newUrl = `${baseUrl}${newPath}`;
                    langLink.href = newUrl;

                    console.log(`Language switcher URL updated: ${newUrl}`);
                }
            }
        },
        goBackToPrograms() {
            // const route = this.site_lang === 'fr' ? '/fr/programs' : '/programs';
            const route = this.site_lang === 'fr' ? '/programs' : '/programs';
            this.router.push({ path: route });
        },
        goBackToSchools() {
            // const route = this.site_lang === 'fr' ? '/fr/schools' : '/schools';
            const route = this.site_lang === 'fr' ? '/schools' : '/schools';
            this.router.push({ path: route });
        },
        printString(string) {
            return window.translations[string];
        },
    }
}
</script>
